import React,{useState}from 'react';
import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import io from 'socket.io-client';
const MessageButton = styled(Button)(({ theme }) => ({
  color:'black',
  backgroundColor: 'white',
  border:"1px !important",
  m:2,
  borderColor:'black !important',
  '&:hover': {
    backgroundColor: '#ffe923',
  },
  position: 'fixed',
  right: '10%',
  bottom: '4vh', 
  textTransform:'lowercase',fontSize:'16px',fontFamily:"verdana",lineHeight:"24px", boxShadow:"none",
    "@media screen and (max-width: 768px)": {
    position: 'absolute',
  right: '3rem',
  bottom:'95%',
 

}}));


const LanguageButton = styled(Button)(({ theme }) => ({
  color:'black',
  backgroundColor: 'white',
  border:1,
  m:2,
  borderColor:'black',
  '&:hover': {
    backgroundColor: '#ffe923',
  },
  position: 'fixed',
  right: '20%',
  bottom: '4vh', 
  textTransform:'lowercase',fontSize:'16px',fontFamily:"verdana",lineHeight:"24px", boxShadow:"none",
    "@media screen and (max-width: 768px)": {
    position: 'absolute',
  right: '10rem',
  bottom:'95%',
 

}}));



const ButtonContainer = styled(Stack)({
    zIndex:10000,
  });
  
 const CustomizedButton= ({
    showModal,
    setShowModal,
  
    }) => {
      const [toggleState, setToggleState] = useState(true);

      const SendMessage = (payload) => {
        let socket_url = process.env.REACT_APP_SOCKET_URL;
    
        var conversation_id = JSON.parse(window.sessionStorage.chat_session).session_id;
        console.log(conversation_id);
        let socket = io(socket_url);
    
        socket.on('connect', () => {
          console.log("Connected to Socket.io server");
        });
    
    
    
        socket.emit('user_uttered',
          { "session_id": conversation_id, "message": payload }
        );
    
      }

      
      const LanguageClick = (e) => {
        if (e.target.classList.contains("devButton")) {
          setToggleState(prevState => !prevState);
          {toggleState ? SendMessage(`/inform{"lang_detect": false}`) : SendMessage( `/inform{"lang_detect": true}`)};
          console.log("Sending langdetect");
        }
      };
    const MessageClick = (e) => {
        if (e.target.classList.contains("devButton")) {
        setShowModal(true)
        }
      };

    return (
      <ButtonContainer spacing={3} direction="row">
        <LanguageButton className="devButton" variant="contained" onClick={LanguageClick}>
          {toggleState ? "translation: ON" : "translation: OFF" }
        </LanguageButton>
        <MessageButton className="devButton" variant="contained" onClick={MessageClick} >
          {"<...>"}
        </MessageButton>
      </ButtonContainer>
    );
  };  export default CustomizedButton;
